import { create } from 'zustand';

interface ReviewPromptState {
  /** Set to true to open the review sheet (used by ReportEdit and for design testing) */
  showReviewSheet: boolean;
  setShowReviewSheet: (value: boolean) => void;
}

export const useReviewPromptStore = create<ReviewPromptState>((set) => ({
  showReviewSheet: false,
  setShowReviewSheet: (value) => set({ showReviewSheet: value }),
}));
